import { IoCloseOutline } from "react-icons/io5";
import { ILocationBookmark } from "./locationBookmarkPanel";
import {
  MdDeleteForever,
  MdEdit,
  MdShare,
  MdOutlineCheck,
} from "react-icons/md";
import Moment from "react-moment";
import { useContext, useState } from "react";
import { getLocationBookmarkUrl } from "../../route/routeHelpers";
import { Themes } from "../../../enums/themes";
import Context from "../../utils/context";
import { useNavigate } from "react-router-dom";

interface BookmarksListProps {
  bookmarks: ILocationBookmark[];
  show: boolean;
  onClose: () => void;
  updateLocationBookmark?: (bookmark: ILocationBookmark) => void;
  removeLocationBookmark?: (id: string) => void;
}

export const BookmarksList = (props: BookmarksListProps) => {
  const context = useContext(Context);
  const navigate = useNavigate();

  const [sharedBookmark, setSharedBookmark] = useState<boolean>(false);
  const [sharedBookmarkId, setSharedBookmarkId] = useState<string>("");

  if (!props.show) return null;

  const handleClose = () => {
    props.onClose();
  };

  const handleView = (event: any, bookmark: ILocationBookmark) => {
    if (event.target.closest("td").cellIndex > 2) {
      return;
    }
    navigate(getLocationBookmarkUrl(bookmark.id));
  };

  const handleEdit = (bookmark: ILocationBookmark) => {
    props.updateLocationBookmark?.(bookmark);
  };

  const handleDelete = (id: string) => {
    props.removeLocationBookmark?.(id);
  };

  const handleShare = (bookmark: ILocationBookmark) => {
    setSharedBookmark(true);
    setSharedBookmarkId(bookmark.id);

    const url = window.location.origin + getLocationBookmarkUrl(bookmark.id);
    navigator.clipboard.writeText(url);

    context.setAlert({
      message: "Location bookmark link copied to clipboard.",
      theme: Themes.Success,
    });
    setTimeout(() => {
      setSharedBookmark(false);
      setSharedBookmarkId("");
    }, 1500);
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 "
      style={{ zIndex: 1 }}
    >
      <div className="relative max-w-4xl w-full bg-white p-6 rounded-lg shadow-md">
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 transition"
          onClick={handleClose}
        >
          <IoCloseOutline size={30} />
        </button>
        <h2 className="text-xl font-semibold text-gray-700 mb-4">
          Saved Locations
        </h2>
        <div className="border rounded-lg">
          <table className="border-collapse table-auto w-full text-sm">
            <thead>
              <tr>
                <th className="border-b border-r font-medium p-4 py-3 text-slate-400 text-center">
                  <div className="items-center">Name</div>
                </th>
                <th className="border-b border-r font-medium p-4 py-3 text-slate-400 text-center">
                  <div className="items-center">Description</div>
                </th>
                <th className="border-b border-r font-medium p-4 py-3 text-slate-400 text-left">
                  <div className="items-center">Date</div>
                </th>
                <th
                  className="border-b font-medium p-4 py-3 text-slate-400 text-center"
                  colSpan={3}
                >
                  <div className="items-center">Actions</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {props.bookmarks != null && props.bookmarks.length > 0 ? props.bookmarks?.map((item: ILocationBookmark) => (
                <tr
                  key={item.id}
                  className="cursor-pointer border-b last-of-type:border-b-0 hover:bg-gray-50"
                  onClick={(event) => handleView(event, item)}
                >
                  <td className="border-r p-4 text-slate-500">{item.name}</td>
                  <td className="border-r p-4 text-slate-500">
                    {item.description}
                  </td>
                  <td className="border-r last-of-type:border-r-0 p-4 text-slate-500">
                    <Moment date={item.created} format="DD/MM/YYYY" />
                  </td>
                  <td
                    className="border-r last-of-type:border-r-0 p-4 text-slate-500 hover:text-logo"
                    onClick={() => handleEdit(item)}
                  >
                    <MdEdit size={20} title="Edit" className="mx-auto" />
                  </td>
                  <td
                    className="border-r last-of-type:border-r-0 p-4 text-slate-500 hover:text-logo"
                    onClick={() => handleShare(item)}
                  >
                    {sharedBookmark && item.id === sharedBookmarkId ? (
                      <MdOutlineCheck
                        size={20}
                        title="Shared"
                        className="mx-auto"
                      />
                    ) : (
                      <MdShare size={20} title="Share" className="mx-auto" />
                    )}
                  </td>
                  <td
                    className="border-r last-of-type:border-r-0 p-4 text-slate-500 hover:text-red-400"
                    onClick={() => handleDelete(item.id)}
                  >
                    <MdDeleteForever
                      size={20}
                      title="Delete"
                      className="mx-auto"
                    />
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan={6} className="border-t border-slate-200 p-4 text-center text-slate-500">
                    No bookmarks found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
